import { listManifests } from 'store/manifests/client';
import { createIcs2ArrivalFromManifest } from 'store/declarations/eu/ics2/arrival/client';
import {
    ICS2ArrivalExclusion,
    ICS2ArrivalView,
} from 'store/declarations/eu/ics2/arrival/ics2-arrival-notification-declaration';
import Notification from 'components/ui/base/notification/Notification';

export const isManifestArrivalEligible = async ({
    id,
    referenceId,
}: {
    id: string;
    referenceId: string;
}): Promise<boolean> => {
    const page = await listManifests({ referenceId, arrivalEligible: true, archived: false, size: 10 });
    return (page.list ?? []).some((manifest) => manifest.id === id);
};

const notifyExclusions = (exclusions: ICS2ArrivalExclusion[]) => {
    if (!exclusions.length) return;

    Notification({
        type: 'error',
        placement: 'top',
        messageTitle: `${exclusions.length} ENS filing${exclusions.length === 1 ? ' is' : 's are'} not referenced.`,
        description: exclusions.map(({ mrn, reason }) => `${mrn ?? 'No MRN'}: ${reason}`).join('\n'),
    });
};

export const createArrivalForManifest = async (manifestId: string): Promise<ICS2ArrivalView> => {
    const { arrival, exclusions } = await createIcs2ArrivalFromManifest(manifestId);

    notifyExclusions(exclusions ?? []);

    return arrival;
};
